import React from "react";
import { useClipboard } from "../../hooks/useClipboard";
import { SxStyleProp } from "theme-ui";
import { Button } from "rebass";
import { animated, useTransition } from "react-spring";

interface Props {
  wordToCopy: string;
  sx?: SxStyleProp;
  label?: string;
  successLabel?: string;
}

const CopyText: React.FunctionComponent<Props> = ({
  wordToCopy,
  sx,
  label = "Copy",
  successLabel = "Copied!",
}) => {
  const { onCopy, hasCopied } = useClipboard(wordToCopy);
  const transitions = useTransition(hasCopied, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0, display: "none", height: 0 },
    initial: null,
  });

  return (
    <Button
      fontSize={1}
      onClick={onCopy}
      type="button"
      sx={{
        background: "transparent",
        ":focus": {
          outline: "none",
        },
        ...(sx as any),
      }}
    >
      {transitions.map(({ item, props }, i) =>
        item ? (
          <animated.span key={i} style={props}>
            {successLabel}
          </animated.span>
        ) : (
          <animated.span key={i} style={props}>
            {label}
          </animated.span>
        ),
      )}
    </Button>
  );
};

export default CopyText;
